import { GMOUDto } from '@cradua/data';
import { environment } from 'apps/epims/mrsoftepims/src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GmouService {
  url = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getGmou(): Observable<GMOUDto[]> {
    return this.http.get<GMOUDto[]>(this.url + 'gmou');
  }

  createGmou(data: GMOUDto): Observable<GMOUDto> {
    return this.http.post<GMOUDto>(this.url + 'gmou', data);
  }

  getSingleGmou(id: string): Observable<any> {
    return this.http.get(this.url + 'gmou/' + id);
  }

  updateGmou(data: GMOUDto): Observable<GMOUDto> {
    return this.http.post<GMOUDto>(this.url + 'gmou/update', data);
  }

  deleteGmou(id: any) {
    return this.http.delete(this.url + 'gmou/' + id);
  }
}
